"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var useTheme_1 = require("@cvent/carina/components/ThemeProvider/useTheme");
var BreakpointsProvider_1 = require("@cvent/carina/components/Breakpoints/BreakpointsProvider");
var BlockContext_1 = require("./BlockContext");
/**
 * Renders an h1 if first block in the stack, otherwise h2
 */
function BlockHeader(_a) {
    var children = _a.children, subtext = _a.subtext, _b = _a.textAlign, textAlign = _b === void 0 ? 'start' : _b, props = __rest(_a, ["children", "subtext", "textAlign"]);
    var index = (0, BlockContext_1.useBlockContext)().index;
    var isHeroBlock = index === 0;
    var font = (0, useTheme_1.useTheme)().font;
    var _c = (0, BreakpointsProvider_1.useBreakpoints)(), isDefaultSize = _c.isDefaultSize, isS = _c.isS;
    var isSmall = isDefaultSize || isS;
    var headerStyles = {
        fontWeight: font.base.weight.bold,
        textAlign: textAlign,
        marginBottom: isSmall ? 16 : 10
    };
    var header = ((0, jsx_runtime_1.jsx)("h2", __assign({ css: headerStyles }, props, { children: children })));
    if (isHeroBlock) {
        header = ((0, jsx_runtime_1.jsx)("h1", __assign({ css: headerStyles }, props, { children: children })));
    }
    var subtextElement;
    if (subtext) {
        subtextElement = ((0, jsx_runtime_1.jsx)("p", __assign({ css: {
                textAlign: textAlign,
                fontSize: isSmall ? font.base.size[4] : font.base.size[6]
            } }, { children: subtext })));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { children: [header, subtextElement] }));
}
exports.default = BlockHeader;
//# sourceMappingURL=BlockHeader.js.map